import React from "react";

const RefundSuccessModal = ({ onClose, currency }) => {
  const isUSD = currency === "USD";

  return (
    <div className="other-purchase-modal-overlay">
      <div className="other-purchase-modal-content success-modal">
        <img
          src="/images/approved.png"
          alt="Refund successful"
          className="success-image"
        />

        <h2>Refund Request Submitted</h2>

        {isUSD ? (
          <p className="modal-subtitle">
            Your refund request has been successfully submitted. Since your
            payment was in USD, the refund will be handled offline between you
            and the host. An email has been sent to both parties to coordinate
            the refund.
          </p>
        ) : (
          <p className="modal-subtitle">
            Your refund request has been successfully submitted and is now
            pending review by the host. You will be notified once the host has
            processed your refund.
          </p>
        )}

        <button className="modal-button proceed-button" onClick={onClose}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default RefundSuccessModal;
